// extracted by mini-css-extract-plugin
module.exports = {"General":"HomeAdmin_General__2KNAf","Title":"HomeAdmin_Title__BpZrE","Title1":"HomeAdmin_Title1__12OfH","img":"HomeAdmin_img__2pIcV","bg":"HomeAdmin_bg__3mU-j"};